import * as Yup from 'yup';
import { DeliveredDocument } from '@models';

export function useValidationSchema() {
  return Yup.object<DeliveredDocument>().shape({
    deliveryDate: Yup.string().nullable().required(),
    summary: Yup.string().nullable().required(),
  });
}
